var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex_box",style:(_vm.styleMerge)},[_c('div',{staticClass:"current-active"}),(_vm.viewData.hotZoneImg.config.imgUrl)?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.viewData.hotZoneImg.config.imgUrl,"alt":""}}):_c('div',[_vm._v(" 请选择图片 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }